import { useQuery } from "@faire/web-api/api/logged-out-homepage/category-brands-banner/get-hooks";

export const useCategoryBrandsBannerQuery = () => {
  const { data, dataUpdatedAt, isFetching } = useQuery({
    gcTime: Infinity,
    staleTime: Infinity,
  });
  return {
    categoryBestBrands: data?.category_brands_carousels,
    dataUpdatedAt,
    isFetching,
  };
};
